import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import { ScoutingAreaFilter } from "@/models/ScoutingArea";
import ScoutingMedium from "@/models/ScoutingMedium";
import { MediumType } from "@/models";
import {
  ScoutingGroupCreateDTO,
  ScoutingGroupUpdateDTO,
} from "@/models/ScoutingGroup";

export const GET_SCOUTING_GROUPS = "get_scouting_groups";
export const GET_SCOUTING_GROUP = "get_scouting_group";
export const SAVE_SCOUTING_GROUP = "save_scouting_group";
export const UPDATE_SCOUTING_GROUP = "update_scouting_group";
export const DELETE_SCOUTING_GROUP = "delete_scouting_group";
export const GET_GOOGLE_SLIDE_SCOUTING_REPORT =
  "get_google_slide_scouting_report";

@Component
export default class ScoutingGroupMixin extends Vue {
  getScoutingGroups(analysisId: string) {
    const path = `${BASE_API_URL}/scoutings/analyses/${analysisId}/scouting_groups`;
    return this.$httpGet(path, GET_SCOUTING_GROUPS);
  }

  getScoutingGroup(id: string) {
    const path = `${BASE_API_URL}/scoutings/scouting_groups/${id}`;
    return this.$httpGet(path, GET_SCOUTING_GROUP);
  }

  saveScoutingGroup(analysisId: string, payload: ScoutingGroupCreateDTO) {
    const path = `${BASE_API_URL}/scoutings/analyses/${analysisId}/scouting_groups`;
    return this.$httpPost(path, SAVE_SCOUTING_GROUP, payload);
  }

  updateScoutingGroup(id: string, payload: ScoutingGroupUpdateDTO) {
    const path = `${BASE_API_URL}/scoutings/scouting_groups/${id}`;
    return this.$httpPut(path, UPDATE_SCOUTING_GROUP, payload);
  }

  deleteScoutingGroup(id: string) {
    const path = `${BASE_API_URL}/scoutings/scouting_groups/${id}`;
    return this.$httpDelete(path, DELETE_SCOUTING_GROUP, {});
  }

  getGoogleSlideReport(id: string) {
    const path = `${BASE_API_URL}scoutings/analyses/${id}/slides_link`;
    return this.$httpGet(path, GET_GOOGLE_SLIDE_SCOUTING_REPORT);
  }
}
